import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import {
  requestAddingUser,
  requestAddingUserForEnterprise,
  closeLinkOrga,
} from "../../redux/actions/usersManagementActionCreators";
import {
  Autocomplete,
  FormHelperText,
  Paper,
  useMediaQuery,
} from "@mui/material";
import LinkOrgaModal from "./LinkOrgaModal";
import { getManagedOrganizatonProfiles } from "../../redux/actions/organizationProfileCreators";
import AutocompleteWithPagination from "../../components/AutocompleteWithPagination";

export default function AddModal({
  open,
  handleClose,
  userEmails,
  users,
  page,
  text,
  tabs,
  filter,
  superAdmin
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const storedUser = localStorage.getItem("user");
  const orgaId = localStorage.getItem("orgaId");

  const [filtredProfiles, setFiltredProfiles] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [selectedOrga, setSelectedOrga] = useState({});
  const [error, setError] = useState(false);
  const [orgaPage, setOrgaPage] = useState(1);
  const [profiles, setProfiles] = useState([]);
  const [input, setInput] = useState("");

  const handleError = (bol) => {
    setError(bol);
  };

  const handleOrganization = (orga) => {
    setSelectedOrga(orga);
  };

  useEffect(() => {
    if (Object.keys(selectedOrga).length > 0) {
      setInput(selectedOrga?.name_A);
    } else {
      setInput("");
    }
    console.log({ selectedOrga });
  }, [selectedOrga]);

  const role = JSON.parse(storedUser).role;

  const organizations = useSelector(
    (state) => state.organizationProfile.managedOrganizations
  );
  const totalPages = useSelector(
    (state) => state.organizationProfile.totalPages
  );

  useEffect(() => {
    setSearchText(input);
  }, [input]);
  
  const handleSearchText = (value) => {
    setInput(value);
    if (Object.keys(selectedOrga).length > 0) {
      handleOrganization({});
    }
  };

  useEffect(() => {
    if (
      role === "enterprise_admin" ||
      role === "enterprise_account_manager" ||
      role === "cytailor_admin"
    ) {
      const timer = setTimeout(() => {
        dispatch(getManagedOrganizatonProfiles(orgaPage, searchText));
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [dispatch, searchText, orgaPage]);

  const handleScroll = (event) => {
    const { scrollTop, clientHeight, scrollHeight } = event.currentTarget;
    if (scrollHeight - scrollTop === clientHeight && totalPages > orgaPage) {
      setOrgaPage(orgaPage + 1);
    }
  };

  useEffect(() => {
    const filtered = profiles.filter((profile) => {
      const isEnterpriseUser = users?.some((user) => {
        return (
          user?.role === "enterprise_user" &&
          user?.organization_id !== null &&
          (user?.organization_id === profile.id || user?.orga_id === profile.id)
        );
      });

      return !isEnterpriseUser;
    });

    let uniqueIds = {};
    let filtredList = filtered.filter((obj) => {
      if (!uniqueIds[obj.id]) {
        uniqueIds[obj.id] = true;
        return true;
      }
      return false;
    });

    setFiltredProfiles(filtredList);
  }, [profiles, users]);

  const toLink = useSelector((state) => state.linkOrga.toLink);

  const handleCloseLink = () => {
    dispatch(closeLinkOrga());
  };

  const baseValidationSchema = Yup.object({
    firstName: Yup.string()
      .required(t("required_field"))
      .min(3, t("short_text"))
      .matches(/^[a-zA-Z\s]*$/, t("no_special_characters")),
    lastName: Yup.string()
      .required(t("required_field"))
      .min(3, t("short_text"))
      .matches(/^[a-zA-Z\s]*$/, t("no_special_characters")),
    email: Yup.string()
      .email(t("valid_email"))
      .max(255)
      .required(t("required_field"))
      .notOneOf(userEmails, t("email_already_exists")),
    entreprise: Yup.string().required(t("required_field")),
    role: Yup.string().required(t("required_field")),
    managedOrganizations: Yup.array(),
  });

  // const enterpriseUserValidationSchema = baseValidationSchema.shape({
  //   enterpriseOrganisation: Yup.number().required("This field is required"),
  // });

  // const validationSchema = (selectedRole) => {
  //   switch (selectedRole) {
  //     case "enterprise_user":
  //       return enterpriseUserValidationSchema;
  //     default:
  //       return baseValidationSchema;
  //   }
  // };

  const formik = useFormik(
    role === "enterprise_admin" || role === "cytailor_admin"
      ? {
          enableReinitialize: true,
          initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            entreprise: JSON.parse(storedUser).entreprise,
            role: superAdmin ? "" : "enterprise_user",
            managedOrganizations: [],
            // enterpriseOrganisation: "",
          },
          validationSchema: baseValidationSchema,

          onSubmit: (values, { resetForm }) => {
            if (
              Object.keys(selectedOrga).length === 0 &&
              values.role !== "cytailor_admin"
            ) {
              setError(true);
            } else {
              dispatch(
                requestAddingUserForEnterprise(
                  values.firstName,
                  values.lastName,
                  values.email,
                  values.role,
                  values.role === "enterprise_user"
                    ? [Number(selectedOrga.id)]
                    : values.managedOrganizations,
                  page,
                  text,
                  tabs,
                  filter,
                  handleClose,
                  resetForm,
                  handleOrganization
                )
              );
            }
          },
        }
      : {
          enableReinitialize: true,
          initialValues: {
            firstName: "",
            lastName: "",
            email: "",
            entreprise: JSON.parse(storedUser).org_name,
          },
          validationSchema: Yup.object({
            firstName: Yup.string()
              .required(t("required_field"))
              .min(3, t("short_text"))
              .matches(/^[a-zA-Z\s]*$/, t("no_special_characters")),
            lastName: Yup.string()
              .required(t("required_field"))
              .min(3, t("short_text"))
              .matches(/^[a-zA-Z\s]*$/, t("no_special_characters")),
            email: Yup.string()
              .email(t("valid_email"))
              .max(255)
              .required(t("required_field")),
            entreprise: Yup.string().required(t("required_field")),
          }),
          onSubmit: (values, { resetForm }) => {
            dispatch(
              requestAddingUser(
                values.firstName,
                values.lastName,
                values.email,
                values.entreprise,
                "user",
                page,
                text,
                tabs,
                filter,
                orgaId
              )
            );
            resetForm({ values: "" });
            handleClose();
            handleOrganization({});
          },
        }
  );

  useEffect(() => {
    setProfiles(organizations);
  }, [organizations]);

  const isMobile = useMediaQuery("(max-width:900px)");
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "50%", padding: "20px " }
            : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
        }}
        disableBackdropClick
        disableEnforceFocus
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center", mb: 1 }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>
        <form onSubmit={formik.handleSubmit}>
          {console.log("values", formik.values)}
          <DialogTitle mb={3}>
            <Typography variant="title4">{t("add_user")}</Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText mb={3}>
              {t("add_user_description")}
            </DialogContentText>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6} mb={1}>
                <Typography variant="subtitle2">{t("surname")}</Typography>
                <TextField
                  error={Boolean(
                    formik.touched.firstName && formik.errors.firstName
                  )}
                  fullWidth
                  helperText={
                    formik.touched.firstName && formik.errors.firstName
                  }
                  margin="normal"
                  name="firstName"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.firstName}
                  placeholder={t("surname")}
                />
              </Grid>
              <Grid item xs={12} md={6} mb={1}>
                <Typography variant="subtitle2">{t("name")}</Typography>
                <TextField
                  error={Boolean(
                    formik.touched.lastName && formik.errors.lastName
                  )}
                  fullWidth
                  helperText={formik.touched.lastName && formik.errors.lastName}
                  margin="normal"
                  name="lastName"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.lastName}
                  placeholder={t("name")}
                />
              </Grid>
              <Grid item xs={12} md={6} mb={1}>
                <Typography variant="subtitle2">
                  {t("email_address")}
                </Typography>
                <TextField
                  error={Boolean(formik.touched.email && formik.errors.email)}
                  fullWidth
                  helperText={formik.touched.email && formik.errors.email}
                  margin="normal"
                  name="email"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.email}
                  placeholder={t("email_address")}
                />
              </Grid>
              {role === "enterprise_admin" || role === "cytailor_admin" ? (
                <>
                  <Grid item xs={12} md={6} mb={1}>
                    <Typography variant="subtitle2">Entreprise</Typography>
                    <TextField
                      error={Boolean(
                        formik.touched.entreprise && formik.errors.entreprise
                      )}
                      fullWidth
                      helperText={
                        formik.touched.entreprise && formik.errors.entreprise
                      }
                      margin="normal"
                      name="entreprise"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.entreprise}
                      placeholder="Entreprise"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "rgb(0 0 0)",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} mb={1}>
                    <Typography variant="subtitle2" mb={2}>
                      Role
                    </Typography>
                    <FormControl
                      fullWidth
                      error={formik.touched.role && Boolean(formik.errors.role)}
                    >
                      <InputLabel>{t("select_role")}</InputLabel>

                      <Select
                        value={formik.values.role}
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        disabled={!superAdmin}
                        onChange={(event) => {
                          formik.setFieldValue("managedOrganizations", []);
                          formik.setFieldValue("enterpriseOrganisation", "");
                          formik.handleChange(event);
                        }}
                        onBlur={formik.handleBlur}
                        label="Role"
                        name="role"
                        error={
                          formik.touched.role && Boolean(formik.errors.role)
                        }
                      >
                        {/* <MenuItem value={"enterprise_account_manager"}>
                          {t("enterprise_account_manager")}
                        </MenuItem>
                        <MenuItem value={"enterprise_risk_manager"}>
                          {t("enterprise_risk_manager")}
                        </MenuItem> */}
                        <MenuItem value={"enterprise_user"}>
                          {t("enterprise_user")}
                        </MenuItem>
                        <MenuItem value={"cytailor_admin"}>
                          {t("cytailor_admin")}
                        </MenuItem>
                      </Select>
                      <FormHelperText>
                        {formik.touched.role && formik.errors.role}
                      </FormHelperText>
                    </FormControl>
                  </Grid>

                  {formik.values.role === "enterprise_account_manager" ? (
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" mb={2}>
                        {t("managed_organizations")}
                      </Typography>

                      <Autocomplete
                        multiple
                        value={profiles.filter((option) =>
                          formik.values.managedOrganizations.includes(option.id)
                        )}
                        name="managedOrganizations"
                        onChange={(e, value) =>
                          formik.setFieldValue(
                            "managedOrganizations",
                            value.map((item) => item.id)
                          )
                        }
                        id="tags-standard"
                        options={profiles}
                        defaultValue={[]}
                        onInputChange={(e) => handleSearchText(e.target.value)}
                        getOptionLabel={(option) => option.name_A}
                        fullWidth
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("select_orga")}
                            helperText={
                              formik.touched.managedOrganizations
                                ? formik.errors.managedOrganizations
                                : ""
                            }
                            error={
                              formik.touched.managedOrganizations &&
                              Boolean(formik.errors.managedOrganizations)
                            }
                          />
                        )}
                      />
                    </Grid>
                  ) : formik.values.role === "enterprise_user" ? (
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" mb={2}>
                        {t("managed_organizations")}
                      </Typography>
                      <AutocompleteWithPagination
                        options={filtredProfiles}
                        isMobile={isMobile}
                        handleSearchText={handleSearchText}
                        selected={selectedOrga}
                        handleSelected={handleOrganization}
                        value={input}
                        error={error}
                        handleError={handleError}
                        handleScroll={handleScroll}
                        organization={true}
                        width={isMobile ? "87%" : "45%"}
                      />
                    </Grid>
                  ) : null}
                </>
              ) : (
                <>
                  <Grid item xs={12} md={6} mb={1}>
                    <Typography variant="subtitle2">
                      {t("display_name_A")}
                    </Typography>
                    <TextField
                      error={Boolean(
                        formik.touched.entreprise && formik.errors.entreprise
                      )}
                      fullWidth
                      helperText={
                        formik.touched.entreprise && formik.errors.entreprise
                      }
                      margin="normal"
                      name="entreprise"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.entreprise}
                      placeholder="Entreprise"
                      disabled
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "rgb(0 0 0)",
                        },
                      }}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ padding: "20px" }}>
            <Grid container>
              <Grid item xs={12} mb={2}>
                <Button
                  variant="contained"
                  color="button"
                  type="submit"
                  fullWidth
                >
                  {t("add_user")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
      <LinkOrgaModal
        open={toLink?.exist_free_account}
        handleClose={handleCloseLink}
        handleCloseAddModal={handleClose}
        toLink={toLink}
        resetForm={formik.resetForm}
        role={formik.values.role}
        firstName={formik.values.firstName}
        lastName={formik.values.lastName}
        managedOrganizations={[Number(selectedOrga.id)]}
        page={page}
        searchText={text}
        tabs={tabs}
        filter={filter}
        handleOrganization={handleOrganization}
      />
    </div>
  );
}
